<template>
  <header
    v-if="usedVariant !== 'no-header'"
    v-bind="$attrs"
    class="the-header flex flex-col pb-300 pt-200 gap-200"
  >
    <div class="content-wrap flex justify-between px-100">
      <section class="flex items-center">
        <HyperLink to="/">
          <img
            :alt="shopPublicName"
            :height="32"
            src="~/assets/img/brand/logo-default.svg"
            :width="204"
          />
        </HyperLink>
      </section>

      <TheHeaderStateSwitch v-if="usedVariant !== 'logo-only'" />
    </div>
  </header>
  <ActiveAnnouncement class="content-wrap px-100 mb-200" />
</template>

<script lang="ts" setup>
import type { TheHeaderVariant } from './types'

type TheHeaderProps = {
  variant?: TheHeaderVariant
}

const { variant = undefined } = defineProps<TheHeaderProps>()

const {
  i18nConfig: { shopPublicName },
} = useRuntimeConfig().public

const usedVariant = computed(() => {
  let { header } = useRoute().meta
  if (typeof variant !== 'undefined') header = variant

  if (typeof header === 'undefined') return 'logo-only'
  if (!header) return 'no-header'
  return header
})
</script>

<style lang="scss" scoped>
.the-header {
  a {
    position: relative;
    display: block;

    @include focus-state {
      &::before {
        inset: -#{token('size/border/200')};
        border-radius: token('size/radius/s');
        box-shadow: 0 0 0 token('size/border/200') token('color/border/accent/focused/focused');
      }
    }
  }
}
</style>
